import { SxProp, View, Image, useDripsyTheme } from 'dripsy';
import React from 'react';
import { UniIconButton } from '../buttons';
import { TextTitle } from '../typography';

interface ModalHeaderProps {
  closeModal: () => void;
  title?: string;
  sx?: SxProp;
  bordered?: boolean;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ closeModal, title, sx, bordered }) => {
  let containerStyles = { ...styles.container, ...sx };
  if (bordered) containerStyles = { ...containerStyles, ...styles.containerBorder };

  return (
    <View sx={containerStyles}>
      <Image
        sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#625f5ce0' }}
        source={require('assets/images/headerBackground2.png')}
      />
      <View>
        {title && (
          <TextTitle bold sx={{ color: '$textModalHeader' }}>
            {title}
          </TextTitle>
        )}
      </View>
      <View sx={{ position: 'absolute', top: 0, right: 0, height: '100%' }}>
        <UniIconButton
          onPress={closeModal}
          icon="cross"
          options={{ iconStyles: { color: '$textModalHeader', themeColor: '$textModalHeader' } }}
          sx={{ position: 'absolute', top: 0, right: 0, height: '100%', padding: '$7', pb: '$7' }}
        />
      </View>
    </View>
  );
};

enum StyleName {
  container = 'container',
  containerBorder = 'containerBorder',
  closeButton = 'closeButton'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    padding: '$7',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  containerBorder: {
    borderBottomWidth: 1,
    borderBottomColor: '$borderPrimary'
  },
  closeButton: {
    height: '$5',
    width: '$5'
  }
};
